import {
	makeStyles,
} from '@material-ui/core';
import {
	Link,
} from 'react-router-dom';
import {
	Button,
} from 'antd';
import {
	formatDate,
	formatTime,
} from '../../utilities';
import {
	SettingsLoading,
	useTournamentSettings,
} from './useTournamentSettings';

const useStyles = makeStyles((theme) => ({
	header: {
		textAlign: 'center',
	},
	flexContainer: {
		paddingTop: 30,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-around',
		[theme.breakpoints.only('xs')]: {
			flexDirection: 'column',
		},
	},
	map: {
		border: 0,
		height: 400,
		width: 400,
		maxWidth: '100%'
	},
	details: {
		paddingBottom: 30,
	},
}));

export function EventDetails() {
	const styles = useStyles();
	const {settings, failed} = useTournamentSettings();

	if (!settings) {
		return <SettingsLoading failed={ failed } />;
	}

	const {event} = settings;

	return (
		<>
			<h1 className={ styles.header }>Fore Nora: A Tournament with Heart</h1>
			<div className={ styles.flexContainer }>
				<div className={ styles.details }>
					<h3>{ event.format }</h3>
					<h3>{ formatDate(event.date, {withWeekday: true}) }</h3>
					<h3>Location: { event.courseName } in { event.courseCity }</h3>
					<h3>Arrive & Check-in: { formatTime(event.checkInStart) } to { formatTime(event.checkInEnd) }</h3>
					<h3>Tee Off: { formatTime(event.teeOff) }</h3>
					{ event.afterPlayText && <h3>{ event.afterPlayText }</h3> }
					<Link to="/register">
						<Button type="outlined">Register Here!</Button>
					</Link>
				</div>
				<div>
					<iframe
						className={ styles.map }
						src={ event.mapEmbedUrl }
						title={ event.courseName }
						allowFullScreen=""
						loading="lazy"
					/>
				</div>
			</div>
		</>

	);
}
